import { render, staticRenderFns } from "./clause.vue?vue&type=template&id=bd00ad64&scoped=true"
import script from "./clause.vue?vue&type=script&lang=js"
export * from "./clause.vue?vue&type=script&lang=js"
import style0 from "./clause.vue?vue&type=style&index=0&id=bd00ad64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd00ad64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd00ad64')) {
      api.createRecord('bd00ad64', component.options)
    } else {
      api.reload('bd00ad64', component.options)
    }
    module.hot.accept("./clause.vue?vue&type=template&id=bd00ad64&scoped=true", function () {
      api.rerender('bd00ad64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/configure/components/clause.vue"
export default component.exports